export const HTS_INDICES = [0, 1, 2, 3] as const;
